import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { Box, Button, InputAdornment, IconButton, Typography, TextField, CircularProgress, Modal as Modal$1, Tabs, Tab, Menu, MenuItem, AppBar, Toolbar, Paper, useTheme, useMediaQuery, Drawer, List, Avatar, LinearProgress } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React, { useState, useContext, useEffect, Fragment as Fragment$1, cloneElement } from 'react';
import { IconContext, NotificationContext, AuthContext, INotificationSeverity, useApi, API } from '@plumeuk/shapeshift-identity';
import { isAxiosError } from 'axios';
import 'x2js';
import { useValidate } from '@plumeuk/use-validate';

const useStyles$i = makeStyles()((_theme) => ({
    navBarLogo: {
        height: "100%",
        maxHeight: "100%",
        "& img": {
            margin: "13px 0",
            height: "65%"
        },
        "&:hover": {
            cursor: "pointer"
        }
    }
}));
const NavNavBarLogoBar = ({ logoPath, className, ...props }) => {
    const { classes, cx } = useStyles$i();
    return (jsx(Box, { className: cx(classes.navBarLogo, className ?? ""), ...props, children: jsx("img", { src: logoPath }) }));
};

const useStyles$h = makeStyles()((theme) => ({
    outlineButton: {
        border: `${theme.palette.secondary.main} 1px solid`,
        color: theme.palette.secondary.main,
        backgroundColor: "transparent",
        "&:hover": {
            backgroundColor: theme.palette.secondary.main + "10"
        }
    }
}));
const OutlineButton = ({ children, className, ...props }) => {
    const { classes, cx } = useStyles$h();
    return (jsx(Button, { className: cx(classes.outlineButton, className), ...props, children: children }));
};

const replaceAll = (str, find, replace) => {
    // Escape special characters in `find` using a regular expression
    const escapedFind = find.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    // Create a regular expression with global flag to replace all occurrences
    const regex = new RegExp(escapedFind, "g");
    // Use the replace method with the regular expression
    return (str ?? "").replace(regex, replace);
};

const useStyles$g = makeStyles()((_theme, { hasError, valid }) => ({
    inputText: {},
    input: {
        border: valid ? "1px solid #d1d1d1" : "1px solid red",
        padding: "10px 20px",
        marginTop: "8px",
        width: "100%",
        boxSizing: "border-box"
    },
    label: {},
    errorMessage: {
        maxHeight: hasError ? 50 : 0,
        color: "#f30000",
        fontSize: "16px",
        boxSizing: "border-box",
        transition: "max-height 0.15s ease-out",
        "& p": {
            paddingTop: "5px"
        }
    }
}));
const InputText = ({ className, label, value, containerProps, error, onValidate, ...props }) => {
    const [showPassword, setShowPassword] = useState(false);
    const valid = error === undefined;
    const { classes, cx } = useStyles$g({ hasError: !!error, valid });
    const { visibilityIcon, visibilityOffIcon } = useContext(IconContext);
    useEffect(() => {
        if (error !== undefined) {
            onValidate?.();
        }
    }, [value]);
    const inputProps = {
        disableUnderline: true,
        autoCapitalize: "none",
        autoComplete: "off"
    };
    if (props.type === "password") {
        inputProps["endAdornment"] = (jsx(InputAdornment, { position: "end", children: jsx(IconButton, { "data-test-id": "input-text-show-password-button", onClick: () => setShowPassword((prev) => !prev), edge: "end", children: showPassword ? visibilityIcon : visibilityOffIcon }) }));
    }
    return (jsxs(Box, { className: cx(classes.inputText, className), ...containerProps, children: [label && jsx(Typography, { className: classes.label, children: label }), jsx(TextField, { className: classes.input, id: "input-text", variant: "standard", autoComplete: 'off', InputProps: { ...inputProps, ...props.InputProps }, value: value, inputProps: {
                    "data-test-id": "text-input-" + (label ? replaceAll(label?.toLocaleLowerCase(), " ", "-") : ""),
                    autoCapitalize: "none",
                    autoCorrect: "off"
                }, onBlur: e => {
                    props?.onBlur?.(e);
                    onValidate?.();
                }, ...props, type: props.type === "password" && showPassword ? "text" : props.type }), jsx("div", { className: classes.errorMessage, children: jsx("p", { children: error ?? " " }) })] }));
};

var Severity;
(function (Severity) {
    Severity[Severity["success"] = 0] = "success";
    Severity[Severity["neutral"] = 1] = "neutral";
    Severity[Severity["warning"] = 2] = "warning";
    Severity[Severity["error"] = 3] = "error";
})(Severity || (Severity = {}));
// //dataKey: name of the state property on result
// //setFtnKey: name of the request function property on result
// //S: State Data
// //R: Request
// //G: Get Data function overide
// export type ITemplatedUseApiReturn<
// 	dataKey extends string, 
// 	setFtnKey extends string, 
// 	S, 
// 	R,
// 	G = APIGetData<R>
// > = {
// 	[K1 in dataKey]: APIState<S>;
// 	a: G;
// 	setData: (data: S) => void;
// }
// const useTemplatedUseApi = <S, R = any>(path: string, data?: S, config?: Omit<FetchRequestStruct<R>, "url">): ITemplatedUseApiReturn<S, R> => {
// 	const request: fetchRequest<R> = config ? {...config, url: path} : path;
// 	const [course, getData, a] = useApi<S>(data ? null : request, data);
// 	const getCourse = (pathOverride?: string, configOverride?: Omit<FetchRequestStruct<R>, "url">): void =>
// 		getData(configOverride
// 			? {...configOverride, url: pathOverride?? path}
// 			: request);
// 	return [course, getCourse, a];
// }

const TEditAccount = {
    password: "",
    confirmPassword: "",
    newPassword: ""
};

const editAccountRequestValidationDoc = {
    confirmPassword: [
        "required",
        "password",
        {
            errorMessage: "passwords do not match",
            validate: (e) => e.confirmPassword === e.newPassword
        }
    ],
    newPassword: [
        "required",
        "password"
    ],
    password: [
        "required"
    ]
};

/* eslint-disable no-console */
console.log.bind(null) ;
console.warn.bind(null) ;
const DevError = console.error.bind(null) ;

const getDueDateString = function (d) {
    const oneDayInMilliseconds = 24 * 60 * 60 * 1000;
    const difference = Math.abs(d.getTime() - new Date().getTime());
    const monthNames = ["January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"];
    if (difference < oneDayInMilliseconds) {
        return "today";
    }
    else if (difference < 6 * oneDayInMilliseconds) {
        const dayOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"][d.getDay()];
        return `on ${dayOfWeek}`;
    }
    else {
        return `on ${d.getDate()} ${monthNames[d.getMonth()]} ${d.getFullYear()}`;
    }
};

const useStyles$f = makeStyles()((theme) => ({
    editAccount: {},
    title: {
        marginBottom: "40px",
        display: "block"
    },
    input: {
        marginTop: "20px"
    },
    buttonContainer: {
        marginTop: "40px",
        display: "flex",
        gap: "10px",
        justifyContent: "space-between",
        "& button": {
            width: "185px",
            [theme.breakpoints.down("sm")]: {
                width: "100%",
                marginBottom: "20px"
            }
        }
    }
}));
const EditAccountPasswordForm = ({ className, onClose, ...props }) => {
    const { classes, cx } = useStyles$f();
    const { notify } = useContext(NotificationContext);
    const { changePassword } = useContext(AuthContext);
    const [formData, setFormData] = useState(TEditAccount);
    const [validationResult, runValidate, hasErrors, clearValidation] = useValidate(editAccountRequestValidationDoc, formData);
    const [postRequestValidation, setPostRequestValidation] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const handleSubmit = async () => {
        setPostRequestValidation({});
        const { password, newPassword, confirmPassword } = formData;
        setIsLoading(true);
        changePassword(password, newPassword, confirmPassword)
            .then(() => {
            notify("", "Password updated!", INotificationSeverity.success, 8000);
            onClose?.();
        })
            .catch((e) => {
            DevError(e);
            setIsLoading(false);
            if (!(isAxiosError(e)))
                return;
            const message = e.response?.data?.error?.message ?? "The password is incorrect";
            if (message.includes("must be different")) {
                setPostRequestValidation({ newPassword: message });
            }
            else if (message.includes("do not match")) {
                setPostRequestValidation({ confirmPassword: message, newPassword: "" });
            }
            else {
                setPostRequestValidation({ password: message });
            }
            setPostRequestValidation({ password: message });
        });
    };
    useEffect(() => {
        setFormData(TEditAccount);
        setPostRequestValidation({});
        clearValidation();
    }, []);
    const input = (label, prop) => (jsx(InputText, { "data-test-id": "edit-account-password-form", className: classes.input, label: label, type: "password", autoComplete: "off", value: formData[prop], error: validationResult[prop] ?? postRequestValidation[prop], onChange: (e) => setFormData(prev => ({ ...prev, [prop]: e.target.value })), onValidate: () => runValidate(prop) }));
    return (jsxs(Box, { className: cx(classes.editAccount, className), ...props, children: [jsxs("form", { autoComplete: "off", children: [input("Current Password", "password"), input("New Password", "newPassword"), input("Confirm Password", "confirmPassword")] }), jsxs(Box, { className: classes.buttonContainer, children: [jsx(Button, { "data-test-id": "edit-account-password-form-submit-btn", disabled: hasErrors, onClick: handleSubmit, children: isLoading ? jsx(CircularProgress, {}) : "Save changes" }), onClose && jsx(OutlineButton, { onClick: onClose, children: "Cancel changes" })] })] }));
};

const useStyles$e = makeStyles()((theme) => ({
    editAccountModal: {},
    closeIcon: {
        position: "absolute",
        top: "20px",
        right: "20px",
        "&:hover": {
            color: theme.palette.secondary.main,
            cursor: "pointer"
        }
    },
    contentContainer: {
        borderRadius: "10px",
        boxSizing: "border-box",
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 500,
        //backgroundColor: theme.palette.background.default,
        backgroundColor: "white",
        padding: "60px",
        [theme.breakpoints.down("sm")]: {
            borderRadius: 0,
            top: "0",
            left: "0",
            overflow: "hidden",
            width: "100%",
            height: "100%",
            transform: "none",
            padding: "30px"
        }
    }
}));
const Modal = ({ className, ...props }) => {
    const { classes, cx } = useStyles$e();
    const { icon } = useContext(IconContext);
    return (jsx(Modal$1, { className: cx(classes.editAccountModal, className), ...props, children: jsxs(Box, { className: classes.contentContainer, children: [jsx(Box, { className: classes.closeIcon, children: icon("closeIcon", {
                        "data-test-id": "modal-close-btn",
                        onClick: props.onClose
                    }) }), props.children] }) }));
};

const useStyles$d = makeStyles()((theme) => ({
    editAccountModal: {},
    modalBody: {
        [theme.breakpoints.down("sm")]: {
            display: "flex",
            height: "100%",
            flexDirection: "column"
        }
    },
    title: {
        marginBottom: "40px",
        display: "block"
    },
    tabs: {},
    form: {
        maxHeight: "600px",
        overflowY: "auto",
        flexGrow: 5
    },
    logoutContainer: {
        margin: "auto",
        textAlign: "center",
        "& svg": {
            position: "relative",
            top: "6px"
        },
        [theme.breakpoints.up("sm")]: {
            display: "none"
        }
    }
}));
const EditAccountModal = ({ className, editUserDetailsForm: EditUserDetailsFormComponent, ...props }) => {
    const { classes, cx } = useStyles$d();
    const { user, logout } = useContext(AuthContext);
    const [tabSelected, setTab] = useState("password");
    const { logoutIcon } = useContext(IconContext);
    const handleTabChange = (_event, newValue) => {
        setTab(newValue);
    };
    return (jsx(Modal, { className: cx(classes.editAccountModal, className), ...props, children: jsxs(Box, { className: classes.modalBody, children: [jsxs(Typography, { variant: "h4", className: classes.title, children: [user?.firstname, " ", user?.lastname] }), jsxs(Tabs, { value: tabSelected, onChange: handleTabChange, children: [jsx(Tab, { value: "password", label: "Password" }), EditUserDetailsFormComponent && jsx(Tab, { value: "accountDetails", label: "Account Details" })] }), jsx("br", {}), jsxs(Box, { className: classes.form, children: [tabSelected === "password" && jsx(EditAccountPasswordForm, { onClose: () => props.onClose?.({}, "backdropClick") }), tabSelected === "accountDetails" && EditUserDetailsFormComponent && jsx(EditUserDetailsFormComponent, { onClose: () => props.onClose?.({}, "backdropClick") })] }), jsxs(Box, { "data-test-id": "edit-account-modal-logout-btn", className: classes.logoutContainer, onClick: () => logout(), children: [logoutIcon, " log out"] })] }) }));
};

const useStyles$c = makeStyles()((theme) => ({
    pageBaseProfile: {},
    iconContainer: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        width: "45px",
        height: "45px",
        cursor: "pointer",
        textAlign: "center",
        borderRadius: 100,
        color: "white",
        margin: "16px",
        backgroundColor: theme["navBar"]?.statusprofile?.backgroundColor,
        "&:hover": {
            border: "1px solid #ffffff50"
        }
    },
    label: {
        display: "flex",
        alignItems: "center"
    },
    bellIconContainer: {
        width: "48px",
        height: "48px",
        borderRadius: "50px",
        backgroundColor: "rgba(255, 255, 255, 0.1)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginTop: "16px"
    },
    bellIcon: {
        color: "#FFFFFF"
    }
}));
const PageBaseProfile = ({ className, disableMenu, disableAccountSettings, editUserDetailsForm, componentOverrides, ...props }) => {
    const { classes, cx } = useStyles$c();
    const { user, logout } = useContext(AuthContext);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const menuOpen = Boolean(anchorEl);
    const [accountModalOpen, setAccountModalOpen] = useState(false);
    const [firstRender, setFirstRender] = useState(true);
    const { icon } = useContext(IconContext);
    useEffect(() => setFirstRender(false), []);
    const handleClick = (event) => {
        if (disableMenu)
            return;
        setAnchorEl(event.currentTarget);
    };
    const handleClose = (ftc) => {
        ftc?.();
        setAnchorEl(null);
    };
    const avatarProps = {
        "data-test-id": "pagebase-profile-avatar",
        className: classes.iconContainer,
        onClick: handleClick
    };
    return (jsxs(Box, { className: cx(classes.pageBaseProfile, className), sx: { display: "inline-flex" }, ...props, children: [jsx(Box, { className: classes.bellIconContainer, children: icon("notificationsNoneOutlinedIcon", {
                    className: classes.bellIcon
                }) }), !firstRender && jsxs(Fragment, { children: [user &&
                        (componentOverrides?.profileAvatar
                            ? componentOverrides.profileAvatar(avatarProps)
                            : jsxs(Box, { ...avatarProps, children: [(user?.firstname ?? user?.email ?? "u")?.charAt(0)?.toUpperCase(), (user?.lastname ?? " ")?.charAt(0)?.toUpperCase()] })), (!user) && jsx("p", { onClick: () => logout(), children: "Logout" }), !disableMenu && jsxs(Menu, { id: "profile-menu", anchorEl: anchorEl, open: menuOpen, onClose: () => handleClose(), sx: { marginTop: "30px" }, MenuListProps: {
                            "aria-labelledby": "basic-button"
                        }, children: [jsx(MenuItem, { "data-test-id": "pagebase-profile-logout-btn", onClick: () => handleClose(logout), children: "Logout" }), !disableAccountSettings &&
                                jsx(MenuItem, { "data-test-id": "pagebase-profile-account-setting-btn", onClick: () => handleClose(() => setAccountModalOpen(true)), children: "Account Setting" })] }), jsx(Typography, { className: classes.label, children: user?.firstname ?? user?.email ?? "user" })] }), jsx(EditAccountModal, { editUserDetailsForm: editUserDetailsForm, open: accountModalOpen, onClose: () => setAccountModalOpen(false) })] }));
};

const NavBarTabs = ({ className, tabs, onTabSelect, icons, tabSelected, ...props }) => {
    return (jsx(Box, { className: "NavBarTabs " + (className ?? ""), ...props, children: jsx(Tabs, { sx: { border: "none" }, value: tabSelected, "aria-label": "shapeshift tabs", children: tabs.map((e, i) => (jsx(Tab, { "data-test-id": `note-card-${e}`, icon: icons?.[i], value: e, onClick: () => onTabSelect(e), label: e?.toString() }, `tab_${i}`))) }) }));
};

function hasChildren(e) {
    return e.children !== undefined;
}
const useStyles$b = makeStyles()((_theme, { disableSideBar }) => ({
    menuIcon: {
        marginRight: "25px",
        cursor: "pointer",
        opacity: disableSideBar ? "0" : "1"
    },
    tabs: {
        flexGrow: 2,
        display: "flex",
        justifyContent: "center"
    },
    logoContainer: {
        display: "flex",
        flexBasis: "150px",
        height: "100%"
    },
    menuIconContainer: {
        display: "flex",
        justifyContent: "center",
        flexDirection: "column"
    },
    toolBar: {
        display: "inline-flex",
        justifyContent: "space-between"
    }
}));
const NavBar = (props) => {
    const { icon } = useContext(IconContext);
    const { children, disableSideBar, disableAccountSettings, logoPath, onPageSelect, pageSelected, onBurgerAction, onLogoClick, editUserDetailsForm, componentOverrides, ...boxProps } = props;
    const { classes } = useStyles$b({ disableSideBar });
    return (jsx(AppBar, { position: "fixed", ...boxProps, children: jsx(Toolbar, { className: classes.toolBar, children: hasChildren(props) ? children : jsxs(Fragment, { children: [jsxs(Box, { className: classes.logoContainer, children: [componentOverrides?.menuIconContainer ? componentOverrides.menuIconContainer({
                                className: classes.menuIconContainer
                            }) :
                                jsx(Box, { className: classes.menuIconContainer, children: icon("menuIcon", {
                                        "data-test-id": "nav-bar-menu-icon",
                                        onClick: onBurgerAction,
                                        className: classes.menuIcon
                                    }) }), jsx(NavNavBarLogoBar, { "data-test-id": "nav-bar-logo-bar", onClick: onLogoClick, logoPath: logoPath })] }), jsx(NavBarTabs, { icons: props.icons, tabs: props.tabs, className: classes.tabs, onTabSelect: onPageSelect ?? (() => { }), tabSelected: pageSelected }), componentOverrides?.pageBaseProfile
                        ? componentOverrides.pageBaseProfile({ disableAccountSettings, editUserDetailsForm })
                        : jsx(PageBaseProfile, { disableAccountSettings: disableAccountSettings, editUserDetailsForm: editUserDetailsForm })] }) }) }));
};

const useStyles$a = makeStyles()((_theme) => ({
    mobileHeader: {},
    profile: {
        borderRadius: "10px",
        display: "flex",
        justifyContent: "space-between",
        marginTop: "25px",
        cursor: "pointer",
        "& > svg": {
            margin: "28px"
        }
    }
}));
const MobileHeader = ({ className, children, editUserDetailsForm, ...props }) => {
    const { classes, cx } = useStyles$a();
    const [editAccountModalOpen, setAccountModalOpen] = useState(false);
    const { keyboardArrowRightIcon } = useContext(IconContext);
    const handleClick = (_e) => {
        setAccountModalOpen(true);
    };
    return (jsxs(Box, { className: cx(classes.mobileHeader, className), ...props, children: [children ? children : jsxs(Fragment, { children: [jsx(Typography, { variant: "h4", children: "Dashboard" }), jsxs(Paper, { "data-test-id": "mobile-header-profile", className: classes.profile, onClick: e => handleClick(), children: [jsx(PageBaseProfile, { disableMenu: true }), keyboardArrowRightIcon] })] }), jsx(EditAccountModal, { editUserDetailsForm: editUserDetailsForm, open: editAccountModalOpen, onClose: () => setAccountModalOpen(false) })] }));
};

const useStyles$9 = makeStyles()((theme) => ({
    notification: {
        pointerEvents: "all",
        backgroundColor: theme.palette.background.paper,
        display: "flex",
        width: "100%",
        overflow: "hidden",
        marginBottom: 15,
        borderRadius: 10,
        boxSizing: "border-box",
        border: "1px solid #d1d1d1",
        zIndex: 5,
        padding: "15px 20px"
    },
    textContainer: {
        flexGrow: 3,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        paddingLeft: "20px",
        paddingRight: "30px"
    },
    icon: {
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        "& svg": {
            fontSize: "50px"
        }
    },
    closeBtn: {
        cursor: "pointer",
        color: "#A8A8A8",
        zIndex: 5,
        "&:hover": {
            color: "black"
        }
    },
    closeContainer: {
        position: "relative",
        display: "flex",
        justifyContent: "center",
        flexDirection: "column"
    },
    title: {
        "& > p": {
            fontWeight: 700,
            margin: "5px 0"
        }
    },
    body: {
        fontSize: 14
    },
    loadingBar: {
        color: "#A8A8A8",
        position: "absolute",
        right: "-9px",
        zIndex: 0,
        "& .MuiCircularProgress-circle": {
            transition: "none"
        }
    }
}));
const Notification = ({ className, notification, ...props }) => {
    const { classes, cx } = useStyles$9();
    const { dismissNotification } = useContext(NotificationContext);
    const [progress, setProgress] = useState(0);
    const { infoIcon, checkCircleIcon, errorIcon, cancelIcon, icon } = useContext(IconContext);
    const close = () => {
        dismissNotification(notification);
    };
    useEffect(() => {
        const calculateProgressPercent = () => {
            if (!notification.lifeTime)
                return 0;
            const secondsPassed = new Date().getTime() - notification.timeAdded.getTime();
            return (secondsPassed / notification.lifeTime) * 100;
        };
        //re calculate progress %
        setProgress(() => !notification.lifeTime ? 0 : calculateProgressPercent());
        if (!notification.lifeTime)
            return;
        const timer = setInterval(() => {
            setProgress(() => {
                const percent = calculateProgressPercent();
                if (percent >= 100)
                    clearInterval(timer);
                return percent > 100 ? 100 : percent;
            });
        }, 50);
        return () => {
            clearInterval(timer);
        };
    }, [notification]);
    let iconColour = "#328DFF";
    let iconE = infoIcon;
    if (notification.severity === INotificationSeverity.success) {
        iconColour = "#32BEA6";
        iconE = checkCircleIcon;
    }
    else if (notification.severity === INotificationSeverity.warning) {
        iconColour = "#FFBA39";
        iconE = errorIcon;
    }
    else if (notification.severity === INotificationSeverity.error) {
        iconColour = "#FE4A49";
        iconE = cancelIcon;
    }
    return (jsxs(Box, { className: cx(classes.notification, className), ...props, children: [jsx("div", { className: classes.icon, style: { color: iconColour }, children: iconE }), jsxs("div", { className: classes.textContainer, children: [jsx("div", { className: classes.title, children: jsx(Typography, { children: notification.title }) }), notification.body && jsx("div", { className: classes.body, children: jsx(Typography, { children: notification.body }) })] }), jsxs("div", { "data-test-id": "notification-" + notification.id, className: classes.closeContainer, onClick: close, children: [icon("closeIcon", { className: classes.closeBtn }), jsx(CircularProgress, { className: classes.loadingBar, variant: "determinate", value: progress })] })] }));
};

const useMq = () => {
    const theme = useTheme();
    const isMobileMq = useMediaQuery(`(max-width:${theme.breakpoints.values.sm - 1}px)`);
    const isTabletMq = useMediaQuery(`(min-width:${theme.breakpoints.values.sm}px) and (max-width:${theme.breakpoints.values.md}px)`);
    const isDesktopMq = useMediaQuery(`(min-width:${theme?.breakpoints.values.md + 1}px)`);
    return {
        mobile: isMobileMq,
        tablet: isTabletMq,
        desktop: isDesktopMq
    };
};

const useCourseAvailableModuleProgression = (slug, data) => {
    const [apiResult, getData, setCourseAvailableModuleProgression] = useApi(data || !slug ? null : API.courseAvailableModuleProgression(slug), data);
    const getCourseAvailableModuleProgression = (slugOverride, configOverride) => {
        const _slug = slugOverride ?? slug;
        if (!_slug)
            return;
        getData(configOverride
            ? { ...configOverride, url: API.courseAvailableModuleProgression(_slug) }
            : API.courseAvailableModuleProgression(_slug));
    };
    useEffect(() => {
        if (data)
            return;
        getCourseAvailableModuleProgression(slug);
    }, [slug, data]);
    useEffect(() => data && setCourseAvailableModuleProgression(data), [data]);
    return { result: apiResult.data, apiResult, getCourseAvailableModuleProgression, setCourseAvailableModuleProgression };
};

const useStyles$8 = makeStyles()((_theme) => ({
    notifications: {
        pointerEvents: "none",
        zIndex: 99,
        position: "fixed",
        right: 20,
        top: 100,
        height: "calc(100% - 60px)",
        width: "500px"
    }
}));
const NotificationDrawer = ({ className }) => {
    const { classes, cx } = useStyles$8();
    const { notifications } = useContext(NotificationContext);
    const mq = useMq();
    //temporary awaiting mobile designs
    if (mq.mobile) {
        // eslint-disable-next-line no-console
        console.warn("notification drawer hidden on mobile pending designs");
        return jsx(Fragment, {});
    }
    return (jsx(Box, { className: cx(classes.notifications, className), children: notifications.map((n, i) => jsx(Notification, { "data-test-id": `notification-${n.id}`, notification: n }, "notification-" + i)) }));
};

const useStyles$7 = makeStyles()((_theme) => ({
    moduleTitle: {}
}));
const PageTitle = ({ title, subtitle, className, ...props }) => {
    const { classes, cx } = useStyles$7();
    return (jsxs(Box, { className: cx(classes.moduleTitle, className), ...props, children: [jsx(Typography, { variant: "h2", children: title }), jsx(Typography, { variant: "h5", style: { opacity: 0.5, marginTop: "10px" }, children: subtitle })] }));
};

const useStyles$6 = makeStyles()((theme) => ({
    centerTileContainer: {
        width: "100%",
        height: "100%",
        display: "flex",
        maxWidth: "740px",
        margin: "auto",
        boxSizing: "border-box",
        flexDirection: "column",
        justifyContent: "center"
    },
    centerTile: {
        position: "relative",
        borderRadius: "10px",
        boxSizing: "border-box",
        background: "#fff",
        width: "100%",
        padding: "70px",
        [theme.breakpoints.down("sm")]: {
            padding: "60px 25px 40px 25px"
        }
    },
    title: {
        marginBottom: "40px",
        "& h2": {
            fontSize: "50px"
        },
        "& h5": {
            fontSize: "28px"
        },
        [theme.breakpoints.down("sm")]: {
            marginBottom: "20px",
            "& h2": {
                fontSize: "30px"
            },
            "& h5": {
                fontSize: "20px"
            }
        }
    },
    icon: {
        marginLeft: "-30px",
        backgroundColor: theme.palette.secondary.main,
        color: "white",
        fontSize: "30px",
        padding: "15px",
        borderRadius: "18px",
        position: "absolute",
        top: "-30px"
    },
    buttonContainer: {
        [theme.breakpoints.down("sm")]: {
            marginTop: "20px",
            flexDirection: "column",
            display: "flex"
        },
        "& button": {
            [theme.breakpoints.down("sm")]: {
                margin: "10px 0"
            },
            [theme.breakpoints.up("sm")]: {
                margin: "0 10px"
            }
        }
    }
}));
const CenterTile = ({ buttons, title, subtitle, icon, className, children, ...props }) => {
    const { classes, cx } = useStyles$6();
    const mq = useMq();
    const buttonContainer = (jsx(Box, { className: classes.buttonContainer, children: buttons?.map((btn, i) => jsx(Fragment$1, { children: btn }, i)) }));
    return (jsxs(Box, { className: cx(classes.centerTileContainer, className), ...props, children: [jsxs(Box, { className: classes.centerTile, children: [mq.mobile && icon && (cloneElement(icon, {
                        className: cx(icon.props.className, classes.icon)
                    })), (title || subtitle) &&
                        jsx(PageTitle, { title: title, subtitle: subtitle, className: classes.title }), children, !mq.mobile && buttonContainer] }), mq.mobile && buttonContainer] }));
};

const useStyles$5 = makeStyles()((theme) => ({
    navBarProfile: {
        textAlign: "center"
    },
    userIcon: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        width: "100px",
        height: "100px",
        borderRadius: 100,
        fontSize: 30,
        color: "white",
        margin: "auto",
        marginTop: "160px",
        backgroundColor: theme["navBar"]?.statusprofile?.backgroundColor
    },
    userName: {
        textAlign: "center",
        color: "white"
    },
    outlineButton: {
        width: "fit-content",
        color: "white",
        margin: "25px auto"
    }
}));
const SideMenuProfile = ({ className, editUserDetailsForm, componentOverrides, ...props }) => {
    const { user } = useContext(AuthContext);
    const { cx, classes } = useStyles$5();
    const [editAccountModalOpen, setAccountModalOpen] = useState(false);
    const [firstRender, setFirstRender] = useState(true);
    const { icon } = useContext(IconContext);
    useEffect(() => setFirstRender(false), []);
    if (firstRender)
        return jsx(CircularProgress, {});
    return (jsxs(Box, { className: cx(classes.navBarProfile, className ?? ""), ...props, children: [user &&
                (componentOverrides?.profileAvatar
                    ? componentOverrides.profileAvatar({ className: classes.userIcon })
                    : jsxs(Box, { className: classes.userIcon, children: [(user?.firstname ?? user?.email ?? "u")?.charAt(0)?.toUpperCase(), (user?.lastname ?? " ")?.charAt(0)?.toUpperCase()] })), jsx("br", {}), jsxs(Typography, { className: classes.userName, variant: "h5", children: [user?.firstname, " ", user?.lastname] }), jsxs(OutlineButton, { "data-test-id": "side-menu-profile-edit-account-btn", className: classes.outlineButton, onClick: () => setAccountModalOpen(true), children: [jsx(Typography, { variant: "body2", children: "Edit account" }), icon("editIcon", {
                        sx: { paddingLeft: "10px", fontSize: "15px" }
                    })] }), jsx(EditAccountModal, { open: editAccountModalOpen, editUserDetailsForm: editUserDetailsForm, onClose: () => setAccountModalOpen(false) })] }));
};

const useStyles$4 = makeStyles()((theme, { isOpen, width }) => ({
    sideMenu: {
        position: "relative",
        left: isOpen ? 0 : (typeof width === "string" ? ("-" + width) : width * -1),
        transition: "all .3s ease-in-out",
        height: "100%",
        zIndex: 10,
        width
    },
    drawer: {
        width,
        height: "100%",
        transition: "all .3s ease-in-out",
        backgroundColor: theme.palette.primary.main,
        "& .MuiDrawer-paper": {
            position: "relative",
            height: "100%",
            backgroundColor: theme.palette.primary.main,
            paddingTop: theme["toolbarHeight"],
            transition: "all .3s ease-in-out",
            width,
            zIndex: theme.zIndex.appBar - 1,
            boxSizing: "border-box"
        }
    }
}));
const SideMenu = ({ children, className, width, editUserDetailsForm, open, componentOverrides, ...props }) => {
    const isOpen = open ?? true;
    const { classes, cx } = useStyles$4({ isOpen, width: width ?? "200px" });
    return (jsx(Box, { className: cx(classes.sideMenu, className), ...props, children: jsx(Drawer, { className: classes.drawer, variant: "permanent", children: children ?
                children :
                componentOverrides?.sideMenuProfile
                    ? componentOverrides?.sideMenuProfile({ editUserDetailsForm: editUserDetailsForm })
                    : jsx(SideMenuProfile, { editUserDetailsForm: editUserDetailsForm }) }) }));
};

const useStyles$3 = makeStyles()(() => ({
    sectionContainer: {
        padding: "20px 30px 32px 30px"
    },
    labelsContainer: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        marginBottom: "5px"
    },
    title: {
        fontWeight: "400",
        fontSize: "16px",
        lineHeight: "35px",
        color: "white"
    },
    titleSecondary: {
        color: "rgba(255,255,255,0.66)"
    }
}));
const SideMenuProfileSection = ({ title, secondaryTitle, children, className, ...props }) => {
    const { classes, cx } = useStyles$3();
    return (jsxs(Box, { className: cx(classes.sectionContainer, className), ...props, children: [jsxs(Box, { className: classes.labelsContainer, children: [jsx(Typography, { className: classes.title, children: title }), jsx(Typography, { className: cx(classes.title, classes.titleSecondary), children: secondaryTitle })] }), children] }));
};

// @TODO: Mobile design needed -> https://plume.eu.teamwork.com/app/tasks/19861692
const useStyles$2 = makeStyles()(() => ({
    listItemContainer: {
        padding: "10px 20px",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        borderBottom: "1px solid #3F3F43",
        ":last-child": {
            borderBottomWidth: "0px"
        }
    },
    textPrimary: {
        fontSize: "16px",
        fontWeight: "400",
        color: "white",
        lineHeight: "24px",
        minWidth: "20px"
    },
    avatar: {
        width: "48px",
        height: "48px"
    },
    textSecondary: {
        fontSize: "14px",
        fontWeight: "400",
        color: "white",
        lineHeight: "24px"
    },
    statsContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
    },
    filler: {
        display: "flex",
        flex: "1"
    },
    leftMargin: {
        marginLeft: "20px"
    },
    listContainer: {
        listStyleType: "none",
        padding: "0px",
        borderWidth: "1px",
        borderColor: "rgba(255,255,255,0.1)",
        borderStyle: "solid",
        borderRadius: "2px"
    }
}));
const SideMenuLeaderboard = ({ list }) => {
    const { classes, cx } = useStyles$2();
    return (jsx(List, { className: classes.listContainer, children: list.map(({ avatar, firstName, lastName, level, rank, xp }, index) => (jsxs(Box, { className: classes.listItemContainer, "data-test-id": `side-menu-leaderboard-item-${replaceAll(firstName, " ", "")}-${replaceAll(lastName, " ", "")}`?.toLocaleLowerCase(), children: [jsx(Typography, { className: classes.textPrimary, children: rank }), jsx(Avatar, { alt: "avatar", className: cx(classes.avatar, classes.leftMargin), src: avatar }), jsx(Typography, { className: cx(classes.textPrimary, classes.leftMargin), children: `${firstName} ${lastName.slice(0, 1)}.` }), jsx(Box, { className: classes.filler }), jsxs(Box, { className: classes.statsContainer, children: [jsxs(Typography, { className: classes.textSecondary, children: ["Lvl ", level] }), jsxs(Typography, { className: classes.textSecondary, children: [xp, " xp"] })] })] }, index))) }));
};

const useStyles$1 = makeStyles()((theme) => ({
    container: {},
    coverContainer: {
        width: "100%",
        height: "150px",
        backgroundColor: "#373737"
    },
    avatarContainer: {
        textAlign: "center",
        paddingBottom: "24px"
    },
    userIcon: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        width: "100px",
        height: "100px",
        borderRadius: 100,
        fontSize: 30,
        color: "white",
        margin: "auto",
        marginTop: "60px",
        marginBottom: "15px",
        letterSpacing: "3px",
        paddingTop: "3px",
        paddingLeft: "3px",
        fontWeight: "700",
        backgroundColor: theme["navBar"]?.statusprofile?.backgroundColor
    },
    name: {
        fontWeight: "500",
        marginTop: "15px"
    },
    section: {
        bottomBorderColor: "rgba(255,255,255,0.1)",
        margin: "0px"
    },
    progressBar: {
        backgroundColor: "rgba(255,255,255,0.1)",
        height: "6px"
    },
    badgesContainer: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between"
    },
    badge: {
        width: "60px",
        height: "60px",
        objectFit: "contain"
    },
    leaderboardContainer: {
        listStyleType: "none",
        padding: "0px",
        borderWidth: "1px",
        borderColor: "rgba(255,255,255,0.1)",
        borderStyle: "solid",
        borderRadius: "2px"
    },
    outlineButton: {
        width: "fit-content",
        margin: "25px auto"
    }
}));
// @TODO: static content. need to add functionality -> https://plume.eu.teamwork.com/app/tasks/19861697
const SideMenuProfileGamification = ({ editUserDetailsForm, ...props }) => {
    const { classes } = useStyles$1();
    return (jsxs(Box, { className: classes.container, ...props, children: [jsx(SideMenuProfile, { editUserDetailsForm: editUserDetailsForm }), jsx(SideMenuProfileSection, { className: classes.section, title: "Level 7", secondaryTitle: "677/700 points", children: jsx(LinearProgress, { variant: "determinate", value: 67, className: classes.progressBar }) }), jsx(SideMenuProfileSection, { title: "Badges", secondaryTitle: "See all (29)", children: jsxs(Box, { className: classes.badgesContainer, children: [jsx("img", { alt: "badge", className: classes.badge, src: "https://shapeshift.ams3.digitaloceanspaces.com/shapeshift-demo-03-2023%2Fbadge-3.png" }), jsx("img", { alt: "badge", className: classes.badge, src: "https://shapeshift.ams3.digitaloceanspaces.com/shapeshift-demo-03-2023%2Fbadge-4.png" }), jsx("img", { alt: "badge", className: classes.badge, src: "https://shapeshift.ams3.digitaloceanspaces.com/shapeshift-demo-03-2023%2Fbadge-1.png" }), jsx("img", { alt: "badge", className: classes.badge, src: "https://shapeshift.ams3.digitaloceanspaces.com/shapeshift-demo-03-2023%2Fbadge-5.png" }), jsx("img", { alt: "badge", className: classes.badge, src: "https://shapeshift.ams3.digitaloceanspaces.com/shapeshift-demo-03-2023%2Fbadge-2.png" })] }) }), jsx(SideMenuProfileSection, { title: "Leaderboard", secondaryTitle: "See all (4)", children: jsx(SideMenuLeaderboard, { list: [
                        { avatar: "https://shapeshift.ams3.digitaloceanspaces.com/shapeshift-demo-03-2023%2Fleaderboard-4.png", firstName: "Chris", lastName: "Rauth", level: 10, rank: 1, xp: 983 },
                        { avatar: "https://shapeshift.ams3.digitaloceanspaces.com/shapeshift-demo-03-2023%2Fleaderboard-1.png", firstName: "Sara", lastName: "Brown", level: 9, rank: 2, xp: 876 },
                        { avatar: "https://shapeshift.ams3.digitaloceanspaces.com/shapeshift-demo-03-2023%2Fleaderboard-2.png", firstName: "Nathan", lastName: "Phillips", level: 8, rank: 3, xp: 788 },
                        { avatar: "https://shapeshift.ams3.digitaloceanspaces.com/shapeshift-demo-03-2023%2Fleaderboard-3.png", firstName: "Loraine", lastName: "Doore", level: 8, rank: 4, xp: 721 }
                    ] }) })] }));
};

const CourseAvailableModuleProgressionDataProvider = ({ children, slug, data }) => {
    const dataHook = useCourseAvailableModuleProgression(slug, data);
    useEffect(() => {
        if (slug && !data)
            dataHook.getCourseAvailableModuleProgression(slug);
    }, [slug]);
    return children?.(dataHook)
        ?? jsx("div", { children: "Please implement children to handle course module progression." });
};

const useStyles = makeStyles()((theme) => ({
    moduleProgressionContainer: {
        background: theme.palette.background.paper
    },
    availableModuleCompletionWidget: {
        display: "flex"
    },
    sectionContainer: {
        display: "flex",
        padding: "20px 20px 20px 30px"
    },
    availableModuleCompletionBar: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "84px",
        minWidth: "84px",
        height: "84px",
        borderRadius: "50%"
    },
    availableModuleCompletionLabels: {
        display: "flex",
        flexFlow: "wrap",
        marginLeft: "16px",
        alignItems: "center",
        alignContent: "center",
        "& h6": {
            fontSize: "16px",
            marginBottom: "4px",
            fontWeight: "700"
        },
        "& p": {
            fontSize: "14px"
        },
        "& span": {
            color: "#3E75E6 !important",
            fontSize: "14px",
            marginLeft: "5px",
            transition: "0.25s",
            "&:hover": {
                cursor: "pointer",
                opacity: "0.7",
                transition: "0.25s"
            }
        }
    },
    availableModuleCompletionCourse: {
        fontSize: "14px"
    },
    availableModulePercentage: {
        fontSize: "15px",
        fontWeight: "700"
    }
}));
const SideMenuModuleProgression = ({ className, data, onGoToModuleLinkAction, course, ...props }) => {
    const { classes, cx } = useStyles();
    const courseSlug = course?.slug;
    return (jsx(Box, { className: cx(classes.sectionContainer, className), ...props, children: jsx(CourseAvailableModuleProgressionDataProvider, { data: data, slug: courseSlug, children: ({ result }) => (jsxs(Box, { className: classes.availableModuleCompletionWidget, children: [jsx(Box, { className: classes.availableModuleCompletionBar, style: {
                            background: `radial-gradient(closest-side, white 62%, transparent 63% 100%), conic-gradient(#00C853 ${result?.progress || 0}%, #D2D2D2 0)`
                        }, children: jsxs(Typography, { className: classes.availableModulePercentage, children: [result?.progress || 0, "%"] }) }), jsxs(Box, { className: classes.availableModuleCompletionLabels, children: [jsx(Typography, { variant: "h6", children: "Assigned tasks completed" }), result?.next && (jsxs(Box, { className: classes.availableModuleCompletionCourse, children: [result.next.dueDate ? `Next Deadline: ${getDueDateString(result.next.dueDate)}` : result.next.title, result?.slug && (jsx(Typography, { "data-test-id": "side-menu-module-progression-see-task-btn", component: "span", onClick: () => onGoToModuleLinkAction?.(courseSlug, result?.next?.type, result?.next?.slug), children: "(See task)" }))] }))] })] })) }) }));
};

export { CenterTile, MobileHeader, NavBar, NavBarTabs, NavNavBarLogoBar, Notification, NotificationDrawer, PageBaseProfile, PageTitle, SideMenu, SideMenuLeaderboard, SideMenuModuleProgression, SideMenuProfile, SideMenuProfileGamification, SideMenuProfileSection };
